import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Formik, Field, getIn } from "formik";
import MaterialTable, { MTableEditRow, MTableEditField } from 'material-table'

//:: All Editable callback must retrun a promise and be executed within a timeout
//   This is obrigatory for the proper function of the library material-table
const editablePromise = callback => {
  return new Promise((resolve, reject) => {
    setTimeout(() => { callback(); resolve(); }, 400)
  })
}

const FormikEditRow = ({ onEditingApproved, formSchema, ...props }) => (
  <Formik
    initialValues={props.data}
    validationSchema={formSchema}
    onSubmit={newData => {
      onEditingApproved(props.mode, newData, props.data);
    }}
  >
    {fkProps => <MTableEditRow {...props} onEditingApproved={fkProps.submitForm} />}
  </Formik>
)

const FormikEditField = props => (
  <Field name={props.columnDef.field}>
    {({ field, form }) => {
      const { name } = field;
      const { errors, setFieldValue } = form;

      const showError = !!getIn(errors, name);

      return (
        <MTableEditField
          {...props}
          {...field}
          error={showError}
          onChange={newValue => setFieldValue(name, newValue)}
        />
      );
    }}
  </Field>
);

function AwesomeTable({ formSchema, columns, data, onDataChange, onConsult, components, ...restProps }) {
  const { t } = useTranslation()

  return (
    <MaterialTable
      localization={t('materialTableLocale', { returnObjects: true })}
      columns={columns}
      data={data}
      editable={{
        onRowAdd: newData => editablePromise(() => {
          onDataChange([...data, newData])
        }),
        onRowUpdate: (newData, oldData) => editablePromise(() => {
          const dataUpdate = [...data];
          dataUpdate[oldData.tableData.id] = newData;

          onDataChange([...dataUpdate]);
        }),
        onRowDelete: oldData => editablePromise(() => {
          const dataDelete = [...data];
          dataDelete.splice(oldData.tableData.id, 1);

          onDataChange([...dataDelete]);
        })
      }}
      components={{
        EditRow: props => <FormikEditRow formSchema={formSchema} {...props} />,
        EditField: FormikEditField,
        ...components
      }}
      initialFormData={{
        firstName: "",
        lastName: ""
      }}
      {...restProps}
    />
  )
}

AwesomeTable.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.elementType
  ]),
  formSchema: PropTypes.object,
  columns: PropTypes.array.isRequired,
  initialData: PropTypes.array,
  onConsult: PropTypes.func,
  components: PropTypes.object,
}

AwesomeTable.defaultProps = {
  title: '',
  initialData: [],
  onConsult: () => true,
  components: {}
}

export default AwesomeTable